import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import CouponService from "services/CouponService";

export const initialState = {
  data: [],
  loading: false,
  error: null,
  redirect: false,
};

export const fetchCouponPrivateData = createAsyncThunk(
  "couponPrivate/fetchCouponPrivateData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText, state } = data;
      const response = await CouponService.get({
        page,
        pageSize,
        sort,
        searchText,
        state,
        isPublic: 0,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const deleteCouponPrivateData = createAsyncThunk(
  "couponPrivate/deleteCouponPrivateData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await CouponService.deleteCoupon(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const couponPrivateSlice = createSlice({
  name: "couponPrivate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCouponPrivateData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(fetchCouponPrivateData.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = false;
        state.data = action.payload.data;
      })
      .addCase(fetchCouponPrivateData.rejected, (state, action) => {
        state.loading = false;
        state.redirect = false;
        state.error = action.error.message;
      })
      .addCase(deleteCouponPrivateData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deleteCouponPrivateData.fulfilled, (state) => {
        state.loading = false;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(deleteCouponPrivateData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default couponPrivateSlice.reducer;
